import React from 'react';
import Builder, { initialValues as builderInitialValues } from '../../components/Chart/Builder';
import Player from '../../components/Chart/Player';

export default {
    handle: 'parentChart',
    label: 'Parent Chart',
    builderInitialValues,
    builder: Builder,
    player: props => <Player type="parent" {...props} />,
};
